import { Configuration as SeguridadAplicativaConfiguration, SeguridadAplicativaResourceApi } from '@conacyt/seguridad-aplicativa-client';

const seguridadAplicativaConfiguration = new SeguridadAplicativaConfiguration({ basePath: '/services/seguridadaplicativa/api' });

const seguridadAplicativaApi = new SeguridadAplicativaResourceApi(seguridadAplicativaConfiguration);

export { seguridadAplicativaApi };
